import axios from 'axios'
import * as types from '../mutation-types'

// namespaced
export const namespaced = true

// state
export const getDefaultState = {
  areas: null,
  selectedArea: {id: '',restaurants: []},
  selectedAreaMode: '',
  postalCodeDialog: false,
  postalCode: null,
  nearestOutlet: null,
  areaMsg: null,
  deliverable: false,
  isExpo: false,
  areaListMode: 0
}

export const state = getDefaultState

// getters
export const getters = {
  areas: state => state.areas,
  selectedArea: state => state.selectedArea,
  selectedAreaMode: state => state.selectedAreaMode,
  postalCodeDialog: state => state.postalCodeDialog,
  postalCode: state => state.postalCode,
  nearestOutlet: state => state.nearestOutlet,
  areaMsg: state => state.areaMsg,
  deliverable: state => state.deliverable,
  isExpo: state => state.isExpo,
  areaListMode: state => state.areaListMode
}

// mutations
export const mutations = {

  [types.FETCH_AREAS] (state, areas) {
    state.areas = areas
  },

  [types.SET_SELECTED_AREA] (state, area) {
    state.selectedArea = area
  },

  [types.RESET_SELECTED_AREA] (state) {
    state.selectedArea = null
  },

  [types.SET_SELECTED_AREA_MODE] (state, mode) {
    state.selectedAreaMode = mode
  },

  [types.RESET_SELECTED_AREA_MODE] (state) {
    state.selectedAreaMode = null
  },

  [types.SHOW_POSTAL_CODE_DIALOG] (state) {
    state.postalCodeDialog = true
  },

  [types.HIDE_POSTAL_CODE_DIALOG] (state) {
    state.postalCodeDialog = false
  },

  [types.FETCH_RESTAURANT_DISTANCE] (state, payload) {
    let restaurant = state.selectedArea.restaurants.find(r => r.ID === payload.restaurant_id)
    restaurant.distance = payload.distance
    restaurant.distanceInfo = payload
    let byDistance = state.selectedArea.restaurants.slice(0)
    // sort by distance
    byDistance.sort(function (a, b) {
      return a.distance - b.distance
    })
    state.selectedArea.restaurants = byDistance
  },

  [types.CLEAR_RESTAURANT_DISTANCE] (state, payload) {
    let restaurant = state.selectedArea.restaurants.find(r => r.ID === payload.ID)
    restaurant.distance = null
  },

  [types.SET_POSTAL_CODE] (state, payload) {
    state.postalCode = payload
  },

  [types.RESET_POSTAL_CODE] (state) {
    state.postalCode = null
  },

  [types.SET_NEAREST_OUTLET] (state, payload) {
    let lowest
    let nearest
    let tmp
    for (let i = payload.length - 1; i >= 0; i--) {
      lowest = lowest || payload[i].distanceInfo.distance
      nearest = nearest || payload[i]
      tmp = payload[i].distanceInfo.distance
      if (tmp <= lowest && payload[i].enableMobileOrder) {
        lowest = tmp
        nearest = payload[i]
      }
    }
    state.nearestOutlet = nearest
    state.areaMsg = nearest.distanceInfo.is_success === 1 ? 'Delivery is available at your area!' : nearest.distanceInfo.message
    state.deliverable = nearest.distanceInfo.is_success === 1
  },

  [types.RESET_NEAREST_OUTLET] (state) {
    state.nearestOutlet = null
  },

  [types.RESET_AREA_MSG] (state) {
    state.areaMsg = null
  },

  [types.RESET_DELIVERABLE] (state) {
    state.deliverable = false
  },

  [types.RESET_STATE] (state) {
    state = getDefaultState
  },

  [types.SET_IS_EXPO] (state) {
    state.isExpo = true
  },

  [types.RESET_IS_EXPO] (state) {
    state.isExpo = false
  },

  [types.SET_AREA_LIST_MODE] (state, payload) {
    state.areaListMode = payload
  },

  [types.RESET_AREA_LIST_MODE] (state) {
    state.areaListMode = 0
  }
}

// actions
export const actions = {
  async fetchAreas ({ commit }) {
    const { data } = await axios.post('/api/areas')
    if (data.code === 1) {
      commit(types.FETCH_AREAS, data.areas)
    }
  },
  async setSelectedArea ({ commit, state }, payload) {
    // payload is area id
    commit(types.RESET_STATE)
    let areas = state.areas
    if (!state.areas) {
      const { data } = await axios.post('/api/areas')
      if (data.code === 1) {
        commit(types.FETCH_AREAS, data.areas)
        areas = data.areas
      }
    }
    const area = areas.find(a => a.id === payload)
    commit(types.SET_SELECTED_AREA, area)
  },
  resetSelectedArea ({ commit }) {
    commit(types.RESET_SELECTED_AREA)
  },
  resetSelectedAreaMode ({ commit }) {
    commit(types.RESET_SELECTED_AREA_MODE)
  },
  setSelectedAreaMode ({ commit }, payload) {
    commit(types.SET_SELECTED_AREA_MODE, payload)
  },
  showPostalCodeDialog ({ commit }) {
    commit(types.SHOW_POSTAL_CODE_DIALOG)
  },
  hidePostalCodeDialog ({ commit }) {
    commit(types.HIDE_POSTAL_CODE_DIALOG)
  },
  async fetchRestaurantDistance ({ commit, state }, payload) {
    let rids = JSON.parse(state.selectedArea.restaurant_ids)
    rids.forEach(id => {
      axios.post('/api/area/distance', { postal_code: payload, restaurant_id: parseInt(id) })
        .then(function (result) {
          commit(types.FETCH_RESTAURANT_DISTANCE, result.data.info)
        })
    })
  },
  clearRestaurantDistance ({ commit, state }) {
    if (state.selectedArea) {
      state.selectedArea.restaurants.forEach(r => {
        commit(types.CLEAR_RESTAURANT_DISTANCE, r)
      })
    }
  },
  setPostalCode ({ commit }, payload) {
    commit(types.SET_POSTAL_CODE, payload)
  },
  resetPostalCode ({ commit }) {
    commit(types.RESET_POSTAL_CODE)
  },
  setNearestOutlet ({ commit, state }) {
    commit(types.SET_NEAREST_OUTLET, state.selectedArea.restaurants)
  },
  resetNearestOutlet ({ commit }) {
    commit(types.RESET_NEAREST_OUTLET)
  },
  resetAreaMsg ({ commit }) {
    commit(types.RESET_AREA_MSG)
  },
  resetDeliverable ({ commit }) {
    commit(types.RESET_DELIVERABLE)
  },
  setIsExpo ({ commit }) {
    commit(types.SET_IS_EXPO)
  },
  resetIsExpo ({ commit }) {
    commit(types.RESET_IS_EXPO)
  },
  setAreaListMode ({ commit }, payload) {
    commit(types.SET_AREA_LIST_MODE, payload)
  },
  resetAreaListMode ({ commit }) {
    commit(types.RESET_AREA_LIST_MODE)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/area.js